export default __webpack_public_path__ + "static/media/66.e08f565c.png";